import { styled } from '@mui/material/styles';

const SvgWrapper = styled('div')(() => ({
  display: 'contents',
}));

export default SvgWrapper;
